module.exports = __webpack_public_path__ + "static/pic02-18ef6e4d4cd063cfa803f9984ba0d5ee.jpg";